import React, { useState, useEffect } from "react";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import localeText from "../../../../../locale";

const EMPLOYEE_OPTIONS = [
  { value: "micro_enterprise_lt10", labelKey: "businessDiagnosisSizeEmployeesMicro" },
  { value: "small_enterprise_10_49", labelKey: "businessDiagnosisSizeEmployeesSmall" },
  { value: "medium_enterprise_50_249", labelKey: "businessDiagnosisSizeEmployeesMedium" },
  { value: "large_enterprise_gte250", labelKey: "businessDiagnosisSizeEmployeesLarge" },
];

const REVENUE_OPTIONS = [
  { value: "lte_2_million", labelKey: "businessDiagnosisSizeRevenueLte2" },
  { value: "2_10_million", labelKey: "businessDiagnosisSizeRevenue2To10" },
  { value: "10_50_million", labelKey: "businessDiagnosisSizeRevenue10To50" },
  { value: "gt_50_million", labelKey: "businessDiagnosisSizeRevenueGt50" },
];

const StepCompanySize = ({ data = {}, onSubmit, onBack, saving }) => {
  const [number_of_employees, setNumberOfEmployees] = useState(null);
  const [revenue, setRevenue] = useState(null);

  useEffect(() => {
    setNumberOfEmployees(data.number_of_employees ?? null);
    setRevenue(data.revenue ?? null);
  }, [data]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      number_of_employees: number_of_employees || null,
      revenue: revenue || null,
    });
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-column gap-3">
      <div>
        <h2 className="text-lg font-semibold m-0 mb-2" style={{ color: "var(--theme-text)" }}>
          {localeText("businessDiagnosisStep3Title") || "Dimensione Azienda"}
        </h2>
        <p className="text-sm m-0 mb-2" style={{ color: "var(--theme-text-muted)" }}>
          {localeText("businessDiagnosisStep3Description") ||
            "Specifica la dimensione della tua impresa per orientarci meglio nel valutare le tue esigenze e il tuo potenziale di crescita."}
        </p>
      </div>
      <div className="p-fluid grid">
        <div className="col-12">
          <label className="block text-sm font-medium mb-1" style={{ color: "var(--theme-text)" }}>
            {localeText("businessDiagnosisStep3LabelEmployees") || "Nr. Dipendenti"}
          </label>
          <Dropdown
            value={number_of_employees}
            options={EMPLOYEE_OPTIONS.map((o) => ({
              value: o.value,
              label: localeText(o.labelKey) || o.value,
            }))}
            onChange={(e) => setNumberOfEmployees(e.value)}
            placeholder={localeText("select") || "Seleziona"}
            className="w-full border-round-md p-no-outline"
          />
          <small className="text-color-secondary">
            {localeText("businessDiagnosisStep3EmployeesHelp") ||
              "Indica la dimensione dell'azienda in base ai dipendenti."}
          </small>
        </div>
        <div className="col-12">
          <label className="block text-sm font-medium mb-1" style={{ color: "var(--theme-text)" }}>
            {localeText("businessDiagnosisStep3LabelRevenue") || "Fatturato"}
          </label>
          <Dropdown
            value={revenue}
            options={REVENUE_OPTIONS.map((o) => ({
              value: o.value,
              label: localeText(o.labelKey) || o.value,
            }))}
            onChange={(e) => setRevenue(e.value)}
            placeholder={localeText("select") || "Seleziona"}
            className="w-full border-round-md p-no-outline"
          />
          <small className="text-color-secondary">
            {localeText("businessDiagnosisStep3RevenueHelp") ||
              "Indica la fascia di fatturato annuale."}
          </small>
        </div>
      </div>
      <div className="flex gap-2 flex-wrap mt-2 justify-content-end">
        {onBack && (
          <Button
            type="button"
            label={localeText("back") || "Indietro"}
            className="p-button-text"
            onClick={onBack}
            disabled={saving}
            style={{ color: "var(--theme-primary)" }}
          />
        )}
        <Button
          type="submit"
          loading={saving}
          disabled={saving}
          className="border-round-md flex align-items-center gap-2 py-3 px-3"
        >
          <span className="text-sm text-white font-medium">{localeText("saveAndContinue")}</span>
          <i className="pi pi-arrow-right text-white text-xs"></i>
        </Button>
      </div>
    </form>
  );
};

export default StepCompanySize;
